/**
 * Created by Languagenut on 28/01/2020.
 */

import AWS from 'aws-sdk'
import ContentService from '../../services/content-service.js'
AWS.config.region = 'eu-west-2'; // Region
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'us-east-1:d040823d-e8eb-4ae6-96cf-58b197731eee',
});


const voices = {
    "en":["Emma", "Amy" , "Brian"],
    "arb":["Zeina"],
    "en-US":["Salli" , "Joanna" , "Matthew" , "Joey"],
    "de-DE":["Hans" , "Marlene" , "Vicki"],
    "es-US":["Miguel","Penelope"],
    "ja-JP":["Mizuki" , "Takumi"],
    'ru-RU':["Tatyana" , "Maxim"],
    'es-ES':["Conchita" , "Lucia" , "Enrique"],
    'es-MX':["Mia"],
    'sv-SE':["Astrid"],
    'cy-GB':["Gwyneth"],
    'tr-TR':["Filiz"],
    'ro-RO':["Carmen"],
    'pt-PT':["Ines" , 'Cristiano'],
    'pt-BR':["Vitoria" , 'Ricardo'],
    'pl-PL':["Ewa" , 'Maja' , 'Jacek' , 'Jan'],
    'nb-NO':["Liv"],
    'ko-KR':["Seoyeon"],
    'it-IT':["Carla" , 'Bianca' , 'Giorgio'],
    'is-IS':["Dora" , 'Karl' ],
    'hi-IN':["Aditi*"],
    'fr-FR':["Celine" , "Mathieu"],
    'nl-NL':["Lotte" , "Ruben"],
    'da-DK':["Naja" , "Mads"],
    'cmn-CN':['Zhiyu'],
};

const getAmazonLanguage = function(){

    return {
        'af':false,
        'al':false,
        'als':false,
        'ar':'arb',
        'bn':false,
        'cn':false,
        'cs':false,
        'cy':'cy-GB',
        'da':false,
        'de':'de-DE',
        'en':'en',
        'es':'es-ES',
        'fa':false,
        'fe':false,
        'fi':false,
        'fr':'fr-FR',
        'gd':false,
        'hand':false,
        'ht':false,
        'hz':false,
        'id':false,
        'islandCUSTOM':false,
        'it':'it-IT',
        'ja':'ja-JP',
        'jis':false,
        'km':false,
        'ko':'ko-KR',
        'kr':false,
        'ku':false,
        'lt':false,
        'lv':false,
        'nl':'nl-NL',
        'no':'nb-NO',
        'pl':'pl-PL',
        'pt':'pt-PT',
        'ro':'ro-RO',
        'ru':'ru-RU',
        'se':'sv-SE',
        'sv':'sv-SE',
        'en-US':'en-US',
        'es-MX':'es-MX',

    }


}

export default class VocabularyGenerator {

    constructParams(text , language){
        return  {
            'Text': text,
            'OutputFormat': 'mp3',
            'VoiceId': voices[language][Math.floor(Math.random() * voices[language].length)]
        }
    }

    makeAudio(text ,  ln)
    {
        var Polly = new AWS.Polly({
            signatureVersion: 'v4',
            region: 'us-east-1'
        });

        var s3 = new AWS.S3();

        var lan = getAmazonLanguage()[ln];


        return ContentService.polly(text , lan , voices[lan][Math.floor(Math.random() * voices[lan].length)]).then(function(path){
            return path;
        }.bind(this))

    }

    generateSound(languageCode , translation){
        if(!getAmazonLanguage()[languageCode]) return {
            available:false,
        };

        return {
            available:true,
            soundPath:this.makeAudio(translation , languageCode).then(function(path){return path}),
            generate:true
        };
    }

    getSound(soundpath , languageCode , translation){

        if(!soundpath)
        {
            return this.generateSound(languageCode , translation);
        }

        return {
            available:true,
            soundPath:soundpath,
            generate:false
        };
    }

    getImage(path)
    {
        if(!path)
        {
            return {
                available:false,
                path:'',
            }
        }

        if(String(path).length <= 3)
        {
            return {
                available:false,
                path:'',
            }
        }


        return {
            available:true,
            path:path,
        }
    }


    getVocabulary(word, language , support){

        return new Promise(function(resolve){

            ContentService.findVocabulary(word  , language , support).then(function(response){

                if(!response)
                {
                    return resolve({
                        word:word,
                        picture:this.getImage(false),
                        sound:this.getSound(false , language , word),
                    })
                }

                if(!response[0] || typeof response[0] == 'undefined')
                {
                    return resolve({
                        word:word,
                        picture:this.getImage(false),
                        sound:this.getSound(false , language , word),
                    })
                }



                return resolve({
                    word:word,
                    picture:this.getImage(response[0].picture),
                    sound:this.getSound(response[0].learningAudio , language , word),
                });

            }.bind(this))


        }.bind(this))

    }
}